import { render, staticRenderFns } from "./OptionCard.vue?vue&type=template&id=2eb1b96a&scoped=true"
import script from "./OptionCard.vue?vue&type=script&lang=ts"
export * from "./OptionCard.vue?vue&type=script&lang=ts"
import style0 from "./OptionCard.vue?vue&type=style&index=0&id=2eb1b96a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb1b96a",
  null
  
)

export default component.exports